import type React from 'react';

import { TrackingContext } from '@change-corgi/core-react/tracking';

import { MembershipAwarenessContainer } from './container/MembershipAwarenessContainer';
import { MembershipAwarenessFormStateContextProvider } from './formState';
import type { Props } from './shared/types';

export const MembershipAwareness: React.FC<Props> = (props) => {
	const { petitionId } = props;

	return (
		<MembershipAwarenessFormStateContextProvider>
			<TrackingContext properties={{ petition_id: petitionId }}>
				<MembershipAwarenessContainer {...props} />
			</TrackingContext>
		</MembershipAwarenessFormStateContextProvider>
	);
};
